import { render, staticRenderFns } from "./RecorderExtensionInstallNoticeCard.vue?vue&type=template&id=61eee831&scoped=true"
import script from "./RecorderExtensionInstallNoticeCard.vue?vue&type=script&lang=ts"
export * from "./RecorderExtensionInstallNoticeCard.vue?vue&type=script&lang=ts"
import style0 from "./RecorderExtensionInstallNoticeCard.vue?vue&type=style&index=0&id=61eee831&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eee831",
  null
  
)

export default component.exports